import { render, staticRenderFns } from "./ViewInfo.vue?vue&type=template&id=313a43e0&scoped=true&"
import script from "./ViewInfo.vue?vue&type=script&lang=js&"
export * from "./ViewInfo.vue?vue&type=script&lang=js&"
import style0 from "./ViewInfo.vue?vue&type=style&index=0&id=313a43e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a43e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313a43e0')) {
      api.createRecord('313a43e0', component.options)
    } else {
      api.reload('313a43e0', component.options)
    }
    module.hot.accept("./ViewInfo.vue?vue&type=template&id=313a43e0&scoped=true&", function () {
      api.rerender('313a43e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/ViewInfo.vue"
export default component.exports